import "core-js/modules/es.array.slice.js";
import "core-js/modules/es.object.freeze.js";
import "core-js/modules/es.object.define-properties.js";
var _templateObject;
function _taggedTemplateLiteral(strings, raw) { if (!raw) { raw = strings.slice(0); } return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }
import styled from 'styled-components';
export var DatePickerStyle = styled.div(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n  .MuiIconButton-root {\n    background-color: transparent;\n    padding: 0;\n  }\n"])));